export enum Order {
  ASC = 'asc',
  DESC = 'desc',
}

export interface ISorter {
  by?: string;
  order?: Order | null;
}

export interface IFilter {
  filterBy: string;
  filterValue: any;
}

export interface IFilterByOption {
  label: string;
  key: string;
}

export type DefaultParams = {
  [key: string]: any;
}

export type FilterByOption = {
  key: string;
  label: string;
  type?: 'toggle' | 'select' | 'text' | 'number' | 'date' | 'date-range-picker' | 'autocomplete' | 'dynamicSearch';
  args?: any;
  triggerQueryOnSelect?: boolean;
  prependIcon?: string;
  placeholder?: string;
  isMobileViewEnabled?: boolean;
}

export enum FilterTypes {
  text = 'text',
  number = 'number',
  select = 'select',
  date = 'date',
  dateRange = 'date-range-picker',
  toggle = 'toggle',
  autocomplete = 'autocomplete',
  dynamicSearch = 'dynamicSearch'
}

export interface ITable {
  query: any;
  queryVariablesKey: string;
  selector: string;
  fields: any;
  showFilters?: boolean;
  showQuickFilters?: boolean;
  showAllFilters?: boolean;
  showPagination?: boolean;
  showDynamicSearch?: boolean;
  dynamicSearchData?: any;
  showItemsPerPage?: boolean;
  showItemsPerPageOnBottom?: boolean;
  filterByOptions?: FilterByOption[];
  defaultParams?: DefaultParams;
  noItemsViewText?: string;
  scopedSlots?: any;
  transformQueries?: (arg: any) => any;
  onDataFetched?: (arg: any) => any;
  classes?: string[];
  sorterIcon?: any;
  responseVariableKey?: string | null;
  searchInformation?: (arg: any) => any;
  actionBtn?: any;
}

export interface ITableFilterProps {
  queries: any;
  onFilterChange: (value: any, filter: string, type: string) => void;
  filterByOptions: FilterByOption[];
  label?: string;
  placeholder?: string;
  showToggle?: boolean;
  isToggleOn?: boolean;
  setIsToggleOn?: (value: boolean) => void;
  toggleLabel?: string;
  clearIcon?: string;
  lazy?: boolean;
}
